'use client'

import { useEffect, useState } from 'react'

import { formatCountdown } from '../lib/quiz-ui'

interface QuizCountdownProps {
  /** ISO do prazo calculado pelo BACKEND. Nulo = quiz sem tempo limite. */
  expiresAt: string | null
  /** Chamado quando o relógio local chega a zero — só para revalidar no servidor. */
  onExpire?: () => void
}

/**
 * Cronômetro do aluno. É um ESPELHO do prazo do servidor, nunca a autoridade:
 * zerar aqui não encerra a tentativa, apenas pede uma revalidação. Quem fecha a
 * tentativa é o backend, no primeiro request que a tocar.
 */
export function QuizCountdown({ expiresAt, onExpire }: QuizCountdownProps) {
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null)

  useEffect(() => {
    if (!expiresAt) {
      setSecondsLeft(null)
      return
    }

    const deadline = new Date(expiresAt).getTime()

    const tick = () => {
      const remaining = Math.max(
        Math.floor((deadline - Date.now()) / 1000),
        0
      )
      setSecondsLeft(remaining)
      if (remaining === 0) onExpire?.()
    }

    tick()
    const interval = window.setInterval(tick, 1000)

    return () => window.clearInterval(interval)
  }, [expiresAt, onExpire])

  if (secondsLeft === null) return null

  const isCritical = secondsLeft <= 30

  return (
    <span
      className={
        isCritical
          ? 'rounded-full bg-[#E0565D] px-3 py-1 text-sm font-bold text-white tabular-nums'
          : 'rounded-full bg-white/70 px-3 py-1 text-sm font-bold text-jacaranda tabular-nums'
      }
      aria-live="polite"
    >
      {formatCountdown(secondsLeft)}
    </span>
  )
}
